import Empresa from "@/features/contabil/common/Empresa";
import {
  IGetAuditoriaResponse,
  IGetAutidoriaWarningResponse
} from "../requests/types";
import EmpresaMapper from "@/features/contabil/common/EmpresaMapperAdapter";
import { IAuditoriaList } from "@/features/contabil/dashboard/widgets/Auditoria/types";

export interface IAuditoriaWarning {
  titulo: string;
  mensagem: string;
  ano: string;
  cor: string;
}

export interface IAuditoria {
  empresa: Empresa;
  warnings: IAuditoriaWarning[];
}

const WARNING_KEY = "dash1";

const DASH_REGIME = "dash2";

export default class Auditoria {
  constructor(readonly response: IGetAuditoriaResponse[] | undefined) {}

  private handleWarnings(
    warnings: IGetAutidoriaWarningResponse[] | undefined
  ): IAuditoriaWarning[] {
    const DashboardWarnings = warnings?.filter((warning) =>
      warning.tags.includes(WARNING_KEY)
    );

    return (
      DashboardWarnings?.map((warning) => ({
        ano: warning.ano || "XX",
        mensagem: warning.mensagem || "",
        titulo: warning.titulo || "Não encontrado",
        cor: warning.cor || "vermelha"
      })) || []
    );
  }

  private handleWarningsDashRegime(
    warnings: IGetAutidoriaWarningResponse[] | undefined
  ): IAuditoriaWarning[] {
    const DashboardWarnings = warnings?.filter((warning) =>
      warning.tags.includes(DASH_REGIME)
    );

    return (
      DashboardWarnings?.map((warning) => ({
        ano: warning.ano || "XX",
        mensagem: warning.mensagem || "",
        titulo: warning.titulo || "Não encontrado",
        cor: warning.cor || "vermelha"
      })) || []
    );
  }

  handler(): IAuditoria[] {
    return (
      this.response?.map((empresa) => ({
        empresa: EmpresaMapper.toEntity(empresa),
        warnings: this.handleWarnings(empresa.warnings)
      })) || []
    );
  }

  handlerDashRegime(): IAuditoria[] {
    return (
      this.response?.map((empresa) => ({
        empresa: EmpresaMapper.toEntity(empresa),
        warnings: this.handleWarningsDashRegime(empresa.warnings)
      })) || []
    );
  }

  createObrigacoesList(data: IAuditoria[]): IAuditoriaList {
    const result =
      data?.map((data) => ({
        empresa: data.empresa,
        list: data.warnings.map((warning) => ({
          description: warning.mensagem,
          title: warning.titulo,
          year: warning.ano,
          color: warning.cor
        }))
      })) || [];

    return {
      data: result
    };
  }
}
